<ng-container *transloco="let t">
  <div class="connection-attempt-banner" [class.failed-retry]="variant === 'failed-retry'">
    <div class="banner-icon">
      <mzic-svg src="assets/icons/mzic-alert-filled.svg" />
    </div>
    <div class="banner-content">
      <p class="banner-title">{{ t(titleKey) }}</p>
      <p class="banner-text">
        @if (customMessage) {
          {{ customMessage }}
        } @else if (messageKey) {
          {{ t(messageKey, { entity: integrationEntityName }) }}
        }
      </p>
    </div>
  </div>
</ng-container>
